import * as ActionTypes from './index';

export function getQuoteScheduleInfo(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULE_INFO,
        payload: payload
    }
}

export function getQuoteScheduleInfoSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULE_INFO_SUCCESS,
        payload: payload
    }
}

export function getQuoteScheduleInfoFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULE_INFO_FAILED,
        payload: payload
    }
}

export function getQuoteProposalForms(payload) {
    return {
        type: ActionTypes.GET_QUOTE_PROPOSAL_FORMS,
        payload: payload
    }
}

export function getQuoteProposalFormsSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_PROPOSAL_FORMS_SUCCESS,
        payload: payload
    }
}

export function getQuoteProposalFormsFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_PROPOSAL_FORMS_FAILED,
        payload: payload
    }
}

export function sendQuoteScheduleViaEmail(payload) {
    return {
        type: ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL,
        payload: payload
    }
}

export function sendQuoteScheduleViaEmailSuccess(payload) {
    return {
        type: ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL_SUCCESS,
        payload: payload
    }
}

export function sendQuoteScheduleViaEmailFailed(payload) {
    return {
        type: ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL_FAILED,
        payload: payload
    }
}

export function resetQuoteState(payload) {
    return {
        type: ActionTypes.RESET_QUOTE_STATE,
        payload: payload
    }
}

export function getQuoteSchedulesMessage(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULES_MESSAGE,
        payload: payload
    }
}

export function getQuoteSchedulesMessageSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULES_MESSAGE_SUCCESS,
        payload: payload
    }
}

export function getQuoteSchedulesMessageFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_SCHEDULES_MESSAGE_FAILED,
        payload: payload
    }
}

export function resetQuoteOptions(payload) {
    return {
        type: ActionTypes.RESET_QUOTE_OPTIONS,
        payload: payload
    }
}

export function getQuoteById(payload) {
    return {
        type: ActionTypes.GET_QUOTE_BY_ID,
        payload: payload
    }
}

export function getQuoteByIdSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_BY_ID_SUCCESS,
        payload: payload
    }
}

export function getQuoteByIdFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_BY_ID_FAILED,
        payload: payload
    }
}

export function getQuotePolicyOverview(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_OVERVIEW,
        payload: payload
    }
}

export function getQuotePolicyOverviewSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_OVERVIEW_SUCCESS,
        payload: payload
    }
}

export function getQuotePolicyOverviewFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_OVERVIEW_FAILED,
        payload: payload
    }
}

export function copyQuote(payload) {
    return {
        type: ActionTypes.COPY_QUOTE,
        payload: payload
    }
}

export function getQuoteMessages(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MESSAGES,
        payload: payload
    }
}

export function getQuoteMessagesSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MESSAGES_SUCCESS,
        payload: payload
    }
}

export function getQuoteMessagesFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MESSAGES_FAILED,
        payload: payload
    }
}

export function getQuoteDefaultSettings(payload) {
    return {
        type: ActionTypes.GET_QUOTE_DEFAULT_SETTINGS,
        payload: payload
    }
}

export function getQuoteDefaultSettingsSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_DEFAULT_SETTINGS_SUCCESS,
        payload: payload
    }
}

export function getQuoteDefaultSettingsFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_DEFAULT_SETTINGS_FAILED,
        payload: payload
    }
}

export function getQuoteIPT(payload) {
    return {
        type: ActionTypes.GET_QUOTE_IPT,
        payload: payload
    }
}

export function getQuoteIPTSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_IPT_SUCCESS,
        payload: payload
    }
}

export function getQuoteIPTFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_IPT_FAILED,
        payload: payload
    }
}

export function handleQuoteProductsChange(payload) {
    return {
        type: ActionTypes.HANDLE_QUOTE_PRODUCTS_CHANGE,
        payload: payload
    }
}

export function updateQuote(payload) {
    return {
        type: ActionTypes.UPDATE_QUOTE,
        payload: payload
    }
}

export function updateQuoteSuccess(payload) {
    return {
        type: ActionTypes.UPDATE_QUOTE_SUCCESS,
        payload: payload
    }
}

export function updateQuoteFailed(payload) {
    return {
        type: ActionTypes.UPDATE_QUOTE_FAILED,
        payload: payload
    }
}

export function changeQuoteRequired(payload) {
    return {
        type: ActionTypes.CHANGE_QUOTE_REQUIRED,
        payload: payload
    }
}

export function changeBrokerCommission(payload) {
    return {
        type: ActionTypes.CHANGE_BROKER_COMMISSION,
        payload: payload
    }
}

export function createQuote(payload) {
    return {
        type: ActionTypes.CREATE_QUOTE,
        payload: payload
    }
}

export function createQuoteSuccess(payload) {
    return {
        type: ActionTypes.CREATE_QUOTE_SUCCESS,
        payload: payload
    }
}

export function createQuoteFailed(payload) {
    return {
        type: ActionTypes.CREATE_QUOTE_FAILED,
        payload: payload
    }
}

export function changeQuoteClientDetailsForm(payload) {
    return {
        type: ActionTypes.CHANGE_QUOTE_CLIENT_DETAILS_FORM,
        payload: payload
    }
}

export function getQuoteStatuses(payload) {
    return {
        type: ActionTypes.GET_QUOTE_STATUSES,
        payload: payload
    }
}

export function getQuoteStatusesSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_STATUSES_SUCCESS,
        payload: payload
    }
}

export function getQuoteStatusesFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_STATUSES_FAILED,
        payload: payload
    }
}

export function getQuoteQuestions(payload) {
    return {
        type: ActionTypes.GET_QUOTE_QUESTIONS,
        payload: payload
    }
}

export function getQuoteQuestionsSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_QUESTIONS_SUCCESS,
        payload: payload
    }
}

export function getQuoteQuestionsFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_QUESTIONS_FAILED,
        payload: payload
    }
}

export function changeQuoteState(payload) {
    return {
        type: ActionTypes.CHANGE_QUOTE_STATE,
        payload: payload
    }
}
export function getQuoteMinimumPricing(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MINIMUM_PRICING,
        payload: payload
    }
}

export function getQuoteMinimumPricingSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MINIMUM_PRICING_SUCCESS,
        payload: payload
    }
}

export function getQuoteMinimumPricingFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_MINIMUM_PRICING_FAILED,
        payload: payload
    }
}


export function getQuotePolicyWordings(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_WORDINGS,
        payload: payload
    }
}

export function getQuotePolicyWordingsSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_WORDINGS_SUCCESS,
        payload: payload
    }
}

export function getQuotePolicyWordingsFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POLICY_WORDINGS_FAILED,
        payload: payload
    }
}
export function getQuotePointsOfSale(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POINTS_OF_SALE,
        payload: payload
    }
}

export function getQuotePointsOfSaleSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POINTS_OF_SALE_SUCCESS,
        payload: payload
    }
}

export function getQuotePointsOfSaleFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTE_POINTS_OF_SALE_FAILED,
        payload: payload
    }
}
